<template lang="pug">
#bloco-dados-contrato-originacao
    el-card(shadow='never', :body-style='{ padding: "16px" }')
        h2.mb-3 Dados do contrato de originação

        .bloco-dados-contrato-originacao__informacoes
            .bloco-dados-contrato-originacao__informacao
                h4 N. Contrato
                p {{ dados.numeroContrato }}

            .bloco-dados-contrato-originacao__informacao
                h4 Cultura
                p {{ dados.culturaNome }}

            .bloco-dados-contrato-originacao__informacao
                h4 Safra
                p {{ dados.safraNome }}

            .bloco-dados-contrato-originacao__informacao
                h4 Volume contratado (t)
                p {{ dados.volumeContratado }}

            .bloco-dados-contrato-originacao__informacao
                h4 Data do contrato
                p {{ dados.dataContrato }}
</template>

<script>
export default {
    name: 'BlocoDadosContratoOriginacao',

    props: {
        dados: {
            required: true,
            type: Object
        }
    },

    data() {
        return { };
    }
};
</script>

<style lang="scss" scoped>
#bloco-dados-contrato-originacao {
    .bloco-dados-contrato-originacao__informacoes {
        display: flex;
        justify-content: space-between;

        h4 {
            font-weight: bold;
            color: var(--primary);
        }
    }
}
</style>
